// src/components/Layout/PageTrackingWrapper.js
import { usePageTracking } from './utils/usePageTracking';

export default function PageTrackingWrapper() {
  usePageTracking();
  return null; // doesn't render anything, just runs the hook
}
